import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const payrollCard = style({
  maxWidth: '43rem',
  padding: themeVars.spacing.lg,
});

export const css = { payrollCard };
